// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"6b3f4c0c","195":"565aecb1","231":"e13149d9","340":"0165316d","709":"2b4aa6ef","863":"f867e821","927":"57dc13c8"}[chunkId] + ".chunk.js";
};